import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { GetCountOfTacticsChannels } from 'generated/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_COUNT_OF_TACTICS_CHANNELS_LAZY = gql`
query GetCountOfTacticsChannels($filters: DashboardFilter!) {
  getCountOfTacticsChannels(filters: $filters) {
    categoryName
    count
    cumulativePercent
  }
}
`;

type ResultType = {
  getCountOfTacticsChannels: GetCountOfTacticsChannels[];
};

type UseGetCountOfTacticsChannelsLazyQuery = () => {
  getCountOfTacticsChannelsLazyQuery: Function;
  loading: boolean;
  error?: ApolloError;
  data: GetCountOfTacticsChannels[];
};

const useGetCountOfTacticsChannelsLazyQuery: UseGetCountOfTacticsChannelsLazyQuery = () => {
  const [
    getCountOfTacticsChannelsLazyQuery,
    { data, loading, error },
  ] = useLazyQuery<ResultType>(GET_COUNT_OF_TACTICS_CHANNELS_LAZY, {
    fetchPolicy: 'cache-and-network',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName:
        'getCountOfTacticsChannelsLazyQuery.ts - useGetCountOfTacticsChannelsLazyQuery',
    });
  }

  return {
    getCountOfTacticsChannelsLazyQuery,
    data: data?.getCountOfTacticsChannels || [],
    loading,
    error,
  };
};

export default useGetCountOfTacticsChannelsLazyQuery;
